﻿import { Ask, GameInfo, Respond } from "./interface/Client";
import { L } from "./l";
interface GameState{
    wordList: string[];
    guessed: number[];
    good: { word: string; el: HTMLDivElement }[];
    bad: { word: string; el: HTMLDivElement }[];
    numPlays: number;
    plays: Respond[];
}
module GameState{

}

var redraw = (gs: GameState) => {
    if (gs.numPlays > 0) {
        var h2 = L.dqs("#h2") as HTMLImageElement;
        h2.src = "res/heart_empty.svg"
    }
    if (gs.numPlays > 1) {
        var h1 = L.dqs("#h1") as HTMLImageElement;
        h1.src = "res/heart_empty.svg"
    }
    for(var g of gs.good){
        g.el.innerText = g.word;
    }
    for (var b of gs.bad) {
        b.el.innerText = b.word;
    }
    var goodWordsSet = new Set(gs.good.map(w => w.word));
    var badWordsSet = new Set(gs.bad.map(w => w.word));

    for (var z = 0; z < gs.plays.length; ++z) {
        if (!gs.plays[z].word)
            continue;
        var play = gs.plays[z].word.toUpperCase();
        if (goodWordsSet.has(play)) {
            goodWordsSet.delete(play);
        }
        if (badWordsSet.has(play)) {
            badWordsSet.delete(play);
        }
    }

    for(var g of gs.good){
        if (goodWordsSet.has(g.el.innerText)) {
            g.el.style.visibility = "visible";
        }else{
            g.el.style.visibility = "hidden";
        }
    }
    for (var b of gs.bad) {
        if (badWordsSet.has(b.el.innerText)) {
            b.el.style.visibility = "visible";
        }else{
            b.el.style.visibility = "hidden";
        }
    }
}
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  function sanitize(str) {
    if (!str)
        return str
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      "/": '&#x2F;'
    };
    const reg = /[&<>"'/]/ig;
    return str.replace(reg, (match)=>(map[match]));
  }

var btn = new L.ButtonListener("#invisBtn");
btn.SetHotkeys({ "Enter": ["#invisBtn"] })
window.onload = async () => {
    btn.Bind();
    var gameState: GameState = { wordList: [], guessed: [], good: [], bad: [], numPlays: 0, plays: [] };
    var gi = await L.Get<GameInfo>(`${url()}/api/daily`,3);

    gameState.wordList = gi.wordList.map(w => w);

    var goodSquares:HTMLDivElement[] = [];
    for (var i = 0; i < gi.goodWords.length; ++i){
        goodSquares.push(<HTMLDivElement>L.dqs(`#sqG${i}`));
        gameState.good.push({ el: goodSquares[i], word: gi.goodWords[i] });
    }
    var badSquares:HTMLDivElement[] = [];
    for (var i = 0; i < gi.badWords.length; ++i){
        badSquares.push(<HTMLDivElement>L.dqs(`#sqB${i}`));
        gameState.bad.push({ el: badSquares[i], word: gi.badWords[i] });
    }
    
    redraw(gameState);
    var cb = L.dqs("#chatboxTextbox") as HTMLTextAreaElement;

    var gameOver = false;
    while(true){

        // wait until the user clicks the button
        await btn.Click("#invisBtn");

        // pull data from textbox
        var userQ = cb.value ?? "";
        if (userQ == "")
            continue;
        cb.value = "";

        if (gameOver)
            continue;

        var thisTurn:string[] = [];
        // send data to server asking for a response
        while (true) {
            var ask: Ask = { q: userQ, id: gi.id, guessed: gameState.guessed };
            var msg = await L.Post<Respond>({
                url: `${url()}/api/ask`,
                data: ask,
                retries: 3
            });
            if (msg.error) {
                L.dqs("#robotBox").style.opacity = "1";
                L.dqs("#robotText").style.opacity = "0";
                L.dqs("#robotTextPre").innerHTML = ``;
                L.dqs("#robotText").innerText = " Error, " + msg.error + "! ";
                L.dqs("#robotTextPost").innerHTML = ``;
                L.dqs("#robotText").style.opacity = "1";
                break;
            }
            L.dqs("#robotBox").style.opacity = "1";
            L.dqs("#robotText").style.opacity = "0";

            var top3 = msg.top3.map(w => sanitize(w).toLowerCase());
            var wToHtml = (w: string) => {
                var wU = sanitize(w.toUpperCase());
                if (gi.goodWords.findIndex(a => a.toUpperCase() == wU) != -1)
                    return `<div class="rtGreen">${wU}</div>`;
                return `<div class="rtRed">${wU}</div>`;
            };

            var wordsToAndList = (ws: string[]) => {
                return L.convertToCommaSeperatedString(ws.map(w => wToHtml(w)));
            };

            var cHtml = `<div class="rtGrey">${sanitize(ask.q).toUpperCase()}</div>`;
            L.dqs("#robotTextPre").innerHTML = `For ${cHtml} I like ${wordsToAndList(top3)}.`;
            L.dqs("#robotText").innerText = msg.whyRelated;
            L.dqs("#robotTextPost").innerHTML = `I choose...`;
            L.dqs("#robotText").style.opacity = "1";
            thisTurn.push(msg.word);
            gameState.plays.push(msg);
            gameState.guessed.push(msg.idxWord)
            var estWords = msg.whyRelated.length/4.5 +4;
            var avgReadSpeedSeconds = estWords / (250.0 / 60.0);
            await sleep(1000+avgReadSpeedSeconds * 1000);
            L.dqs("#robotTextPost").innerHTML = `I choose... ${wToHtml(msg.word)}.`;
            await sleep(2000);
            redraw(gameState);

            //count the number of words left
            var guesses = new Set(gameState.guessed.map(idx => gameState.wordList[idx].toUpperCase()));
            var goodWordsPicked = gi.goodWords.filter(gw => guesses.has(gw.toUpperCase())).length;
            var goodWordsLeft = gi.goodWords.filter(gw => !guesses.has(gw.toUpperCase())).length;
            console.log("");
            if (goodWordsLeft == 0) {
                L.dqs("#robotTextPost").innerHTML = ``;
                L.dqs("#robotTextPre").innerHTML = ``;
                L.dqs("#robotText").innerHTML = `YOU WIN!`;
            }

            if (gi.goodWords.findIndex(a => a.toUpperCase() == msg.word.toUpperCase()) == -1) {
                gameState.numPlays++;
                var guessWas = "guesses were";
                if (thisTurn.length <= 1)
                    guessWas = "guess was";
                L.dqs("#robotTextPre").innerHTML = `Ok, for ${cHtml} my ${guessWas} ${wordsToAndList(thisTurn)}.`;
                if (gameState.numPlays == 1)
                    L.dqs("#robotText").innerHTML = ``;
                else if (gameState.numPlays == 2)
                    L.dqs("#robotText").innerHTML = `You have 1 more try left.`;
                L.dqs("#robotTextPost").innerHTML = ``;
                if (gameState.numPlays == 3){
                    L.dqs("#robotText").innerHTML = `Your score was ${goodWordsPicked}!`;
                    L.dqs("#robotTextPost").innerHTML = `GG`;
                    gameOver = true;
                }
                redraw(gameState);
                break;
            }
        }
    }
}

function url() {
    if (L.isLocalNetwork())
        return "http://127.0.0.1:5287";
    // return https://<blah>.isotropic.us;
    return `${window.location.origin}`;
}